import { gql } from '@apollo/client';

export const GET_PDFS_FROM_POLICY = gql`
  query POLICY_SERVICE_getPolicyByEnrollmentId($periodId: String!) {
    getPolicyByEnrollmentId(periodId: $periodId) {
      pdfs {
        id
        name
        creationDate
        signatureRequestDate
        availability
      }
      finalZip {
        id
        name
        creationDate
        availability
      }
      additionalOutputsZip {
        id
        name
        creationDate
        availability
      }
      outputFiles {
        id
        name
        creationDate
        availability
      }
      finalCsvZip {
        id
        name
        availability
      }
      productOutputs {
        link
        name
        type
        creationDate
        availability
      }
      filesFromDocx {
        id
        name
        creationDate
        availability
      }
    }
  }
`;

export const GET_POLICY_BY_GROUP_ID = gql`
  query POLICY_SERVICE_getPolicyByGroupId($groupId: String!) {
    getPolicyByGroupId(groupId: $groupId) {
      id
      imqFiles
    }
  }
`;

export const GET_ADDITIONAL_OUTPUTS_BY_PERIOD_ID = gql`
  query POLICY_SERVICE_getAdditionalOutputsByPeriodId($periodId: ID!, $subscriberId: ID) {
    getAdditionalOutputsByPeriodId(periodId: $periodId, subscriberId: $subscriberId) {
      id
      name
      creationDate
    }
  }
`;

export const GET_FINAL_ZIPS_BY_PERIOD_IDS = gql`
  query POLICY_SERVICE_getFinalZipsByPeriodIds($periodIds: [String!]!) {
    getFinalZipsByPeriodIds(periodIds: $periodIds) {
      effectiveDate
      zipId
      zipName
    }
  }
`;

export const GET_ADDITIONAL_OUTPUT_ZIPS_BY_PERIOD_IDS = gql`
  query POLICY_SERVICE_getAdditionalOutputsZipByPeriodIds($periodIds: [String!]!) {
    getAdditionalOutputsZipByPeriodIds(periodIds: $periodIds) {
      effectiveDate
      zipId
      zipName
    }
  }
`;

export const GET_GROUPS_INFO_BY_DATE = gql`
  query POLICY_SERVICE_getGroupsInfoBy($from: String, $to: String, $fullView: Boolean = false) {
    getGroupsInfoBy(from: $from, to: $to, fullView: $fullView) {
      groupName
      agencyName
      aorName
      submittedBy
      submittedDate
      effectiveDate
      productLine
      groupId
    }
  }
`;

export const GET_POLICIES_BY_RANGE = gql`
  query POLICY_SERVICE_getPoliciesByRange(
    $from: String!
    $to: String!
    $sponsorId: String
    $step: String! = ""
    $page: Int = 1
  ) {
    getPoliciesByRange(from: $from, to: $to, sponsorId: $sponsorId, step: $step, page: $page) {
      result {
        id
        generationStep
        sequentialGroupId
        creationDate
        sequentialProductLineIds
        enrollmentPeriod {
          id
          domainId
          effectiveDate
          type
        }
        group {
          id
          name
          carrierGroupNumber
        }
        agency {
          name
        }
      }
      totalElements
      currentPage
      totalPages
    }
  }
`;

export const SET_GENERATION_STEP = gql`
  mutation POLICY_SERVICE_setGenerationStep($policyId: String!, $step: GenerationStep!) {
    setGenerationStep(policyId: $policyId, step: $step) {
      id
    }
  }
`;

export const GENERATE_EDI_MANUALLY = gql`
  mutation POLICY_SERVICE_generateEdiManually($sponsorId: String!, $policyIds: [String]) {
    generateEdiManually(sponsorId: $sponsorId, policyIds: $policyIds)
  }
`;

export const SIGNATURE_REQUEST_FOR_FILE = gql`
  mutation POLICY_SERVICE_signatureRequestForFile($periodId: String!, $file: FileInput!) {
    signatureRequestForFile(periodId: $periodId, file: $file)
  }
`;

export const TRIGGER_ALLIED_WELCOME_LETTER = gql`
  mutation POLICY_SERVICE_triggerAlliedWelcomeLetter($periodId: String!) {
    triggerAlliedWelcomeLetter(periodId: $periodId)
  }
`;

export const TRIGGER_ALLIED_CONFIRMATION_LETTER = gql`
  mutation POLICY_SERVICE_triggerAlliedConfirmationLetter($periodId: String!) {
    triggerAlliedConfirmationLetter(periodId: $periodId)
  }
`;
